import {
    GET_LEGAL_AGREEMENT,
	SAVE_LEGAL_AGREEMENT,} from '@/store/actions.type'
import { mapActions, mapGetters } from 'vuex'
import { fixLegalAgreementHtml } from '@/utils/fixLegalAgreementHtml'
var axios = require('axios');
export default {
    name: 'headercomponent',
    data() {
        return {
            legalAgreementData:'',
            showModel:true,
            checkboxVal: false,
            booleanValue: false,
            legalAgreementId:0,
            isShowAcceptButton:false,
            isIAcceptEnabled: false,
            memberId:0

        }
    },

    components: {

    },

    created() {
        self.memberId = this.$route.query.memberId;

        if(memberId!=null){
            this.getActiveLegalAgreement("psi",memberId);
        }else{
            if(localStorage.getItem('psitoken')!=null){
                this.getActiveLegalAgreement("psi",localStorage.getItem("uid"));
            }
            else {
                this.getActiveLegalAgreement("psi",null);
                
            }
        }


    },

    computed: {

    },

    methods: {
        ...mapActions({
            getactivelegal: GET_LEGAL_AGREEMENT,
			savelegalagreement: SAVE_LEGAL_AGREEMENT
           }),

           async getActiveLegalAgreement(productCode,userId) {
                var self = this;
                var payload = {
                    userId:userId,
                    productCode: productCode
                };
                await this.getactivelegal(payload).then(result => {
                    if(result!=null){
                        self.isShowAcceptButton = !result.isUserAccepted && userId!=null;
                        self.legalAgreementId = result.id;
                        self.legalAgreementData = fixLegalAgreementHtml(result.description);
                        self.isIAcceptEnabled = true
                        self.legalAgreementId = result.id
                    }

                });
            },

            async saveLegalAgreement() {
                var self = this;
                var payload = {
                    userId:memberId!=0 && memberId != undefined?memberId:localStorage.getItem("uid"),
                    legalAgreementId:self.legalAgreementId,
                    isAccepted:1
                };
                await this.savelegalagreement(payload).then(result => {
                    if(result!=null){
                        if (result.response.success ==  1) {
                            self.isShowAcceptButton = false
                        }
                    }
                });
            },

            check: function(e) {
                if (e.target.checked) {
                    this.booleanValue = true
                    this.$toastr.removeByType('info')
                }else{
                    this.booleanValue = false
                }

            },
            iaccept: function(){
                if (this.booleanValue) {
                    this.saveLegalAgreement()
                }
                else {
                    this.$toastr.Add({
                        name: "", // this is give you ability to use removeByName method
                        msg: "Please accept the agreement", // Toast Message
                        type: "info", // Toast type,
                        position: "toast-top-full-width",
                        clickClose: true, // Click Close Disable
                        timeout: 0,
                        showCloseButton: true,
                    });
                }
            },

    }
}


// WEBPACK FOOTER //
// ./src/assets/js/legalAgreement.js